<template>
  <footer>
    <div class="middle">
      <div class="left">
        <span class="title">Другие фестивали:</span>
        <a class="footer-link" :href="`${$3dParty.berlin2019.link}`" target="_blank">
          <span>{{ $3dParty.berlin2019.title }}</span>
        </a>
        <a class="footer-link footer-link--cannes" :href="`${$3dParty.cannes.link}`" target="_blank">
            <span>{{ $3dParty.cannes.title }}</span>
        </a>
        <a class="footer-link footer-link--kinotavr" :href="`${$3dParty.kinotavr2019.link}`" target="_blank">
            <span>{{ $3dParty.kinotavr2019.title }}</span>
          </a>
          <a class="footer-link footer-link--berlin" :href="`${$3dParty.berlin2020.link}`" target="_blank">
            <span>{{ $3dParty.berlin2020.title }}</span>
          </a>
          <a class="footer-link footer-link--kinotavr" :href="`${$3dParty.kinotavr2020.link}`" target="_blank">
            <span>{{ $3dParty.kinotavr2020.title }}</span>
          </a>
      </div>
    </div>
    <div class="middle">
      <div class="left">
        <span class="title">Редакторы:</span>
        <span>
          Егор Беликов,<br>
          Виолетта Палий
        </span>
      </div>

      <div class="left">
        <span class="title">
          <br>Дизайнер:
        </span>
        <a href="https://dribbble.com/olgoosh" target="_blank">Чупахина Оля</a>
      </div>
      <div class="right">
        <span class="title">
          <br>Разработка:
        </span>
        <a href="https://vk.com/kekzik123" target="_blank">Дмитрий Кузнецов</a>
      </div>
      <div class="right">
        <span class="title">
          <br>В материалах использованы фото:
        </span>
        <span>© La Biennale di Venezia 2019</span>
      </div>
    </div>
    <div class="bottom">
      <span
        class="b-copyright"
      >© Журнал «Искусство кино», {{ $moment() | moment('Y') }} г.<br/>Зарегистрирован в Министерстве печати и информации РФ №01632 от 7.10.92</span>
    </div>
  </footer>
</template>

<script>
export default {
  name: "b-footer",
  inject: ["$3dParty"]
};
</script>

<style scoped lang="sass">
.footer-link
  font-family: Pragmatica
  font-size: 14px
  line-height: 1.57
  &:hover
    opacity: .6
  &--cannes span
    color: #f45152
  &--kinotavr span
    color: #D7BC5B


</style>



// WEBPACK FOOTER //
// src/views/includes/mfooter.vue